import { EditableArea } from 'core/components/shared/ui/EditableArea'

interface IProps {
  contentType: 'html' | 'pdf'
  content: string
}
export const TermsAcdConditionsView = ({ contentType, content }: IProps) => {
  if (contentType === 'pdf') {
    return <embed src={content} width="100%" height="600px"></embed>
  }
  return <EditableArea hideImageActions disabled multiline disableBorder text={content} />
}
